import PageModule from "@eisinc/Overrides/Pages/CheckoutShippingPage";

export * from "@eisinc/Overrides/Pages/CheckoutShippingPage";

export default PageModule;
